export type Side = "top" | "right" | "bottom" | "left";
export type Alignment = "start" | "center" | "end";

type Prettify<T> = {
	[K in keyof T]: T[K];
} & {};

type DeprecatedPlacement = Prettify<Side | `${Side}-${Exclude<Alignment, "center">}`>;

export type DeprecatedPlacementProps = {
	/** @deprecated */
	placement?: DeprecatedPlacement;
};

export type PlacementProps = {
	side?: Side;
	align?: Alignment;
};

export function convertDeprecatedPlacement(deprecated: DeprecatedPlacement): PlacementProps {
	const placement: PlacementProps = { side: "bottom", align: "center" };

	const [side, align] = deprecated.split("-");
	if (side != null && side !== "") {
		placement.side = side as any;
	}

	if (align != null && align !== "") {
		placement.align = align as any;
	}

	return placement;
}
